export function useCustomRouterRedirect() {
  const fetchRedirect = async (path: string) => {
    const result = await useGraphqlQuery('redirectResolver', { url: path }, useGraphqlDefaultClient())
    return result?.data?.redirectResolver
  }

  const fetchPdpRedirect = async (url: string) => {
    const result = await useGraphqlQuery('esProductsBySearch', { search: url }, useGraphqlDefaultClient())
    return result?.data?.esUrlByAlternativeUrl?.url
  }

  return {
    fetchRedirect,
    fetchPdpRedirect,
  }
}
